import { Component, OnInit, Input } from '@angular/core';
import { Client } from '../client/client';
import { Machine } from '../machine/machine';
import { ActivatedRoute, Router } from '@angular/router';
import { MachineService } from '../machine/machineService';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ClientService } from '../client/clientservice';
import { NewMaintenance } from './newmaintenance';
import { DatePipe } from '@angular/common';
import { Authenticate } from '../authenticate/authenticate';
import { User } from '../user/user';
import { MaintenanceService } from '../maintenance/maintenanceService';

@Component({
  selector: 'app-maintenance-create',
  templateUrl: './maintenance-create.component.html',
  styleUrls: ['./maintenance-create.component.css', '../app.component.less'],
  providers: [DatePipe]
})
export class MaintenanceCreateComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private machineservice: MachineService,
    private clientservice: ClientService, private datePipe: DatePipe,
    private maintenanceservice: MaintenanceService,
    private router: Router,) { }

  public Editor = ClassicEditor;
  public inMachine: Machine;
  public inClient: Client;
  public _visitdetails = "";
  public counter: number;
  private jwt: string;
  private userrole: string;
  auth: Authenticate;
  private newPMR: NewMaintenance;
  private currentuser: User;
  redirecturl: string;
  dt: Date;

  ngOnInit(): void {

    this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
    this.jwt = this.auth.jwt;
    let role = this.auth.user.role.name;
    this.currentuser = this.auth.user;
    const id = +this.route.snapshot.paramMap.get('id');
    this.machineservice.getMachine(id).subscribe(resp => {
      this.inMachine = resp;
      this.inClient = resp.client;
    });
  }


  //---------------------------------------------------------------------------
  // Create new PMR 
  //---------------------------------------------------------------------------

  createMPR() {
    this.newPMR = new NewMaintenance;
    this.newPMR.visitdetails = this._visitdetails;
    this.newPMR.client = this.inClient.id;
    this.newPMR.machine = this.inMachine.id;
    this.newPMR.counter = this.counter;
    this.newPMR.user = this.currentuser.id;
    var timestamp = new Date();
    this.datePipe.transform(this.dt, "yyy-MM-dd");
    this.newPMR.dateofvisit = this.dt;
    this.maintenanceservice.createMaintenance(this.newPMR).subscribe(resp => {
      this.machineservice.updateMachineCounter(this.inMachine.id, this.newPMR.counter).subscribe(resp => { console.log(resp); }
      );
      this.newPMR.id = resp.id;
      this.redirecturl = "/maintenances/" + this.newPMR.id;
      this.router.navigateByUrl(this.redirecturl);

    });
  }


}
